import { useEffect, useState } from 'react'
import { listProCompanyPages, type ProCompanyOption } from '../../api/pros'

export default function PagePicker({
  value,
  onSelect,
  disabled = false,
}: {
  value: ProCompanyOption | null
  onSelect: (next: ProCompanyOption | null) => void
  disabled?: boolean
}) {
  const [query, setQuery] = useState(value?.title || '')
  const [items, setItems] = useState<ProCompanyOption[]>([])
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setQuery(value?.title || '')
  }, [value?.id, value?.title])

  useEffect(() => {
    let cancelled = false
    const run = async () => {
      try {
        setLoading(true)
        const rows = await listProCompanyPages(query.trim(), 20)
        if (!cancelled) setItems(rows)
      } catch {
        if (!cancelled) setItems([])
      } finally {
        if (!cancelled) setLoading(false)
      }
    }
    const timer = window.setTimeout(run, 150)
    return () => {
      cancelled = true
      window.clearTimeout(timer)
    }
  }, [query])

  return (
    <div className="relative mt-1">
      <input
        value={query}
        onChange={(e) => {
          setQuery(e.target.value)
          setOpen(true)
        }}
        onFocus={() => setOpen(true)}
        onBlur={() => window.setTimeout(() => setOpen(false), 100)}
        disabled={disabled}
        placeholder="Select a Pixe Page"
        className="w-full rounded-lg border border-white/15 bg-black/30 px-3 py-2"
      />
      {value ? (
        <button
          type="button"
          onClick={() => {
            onSelect(null)
            setQuery('')
          }}
          className="mt-1 text-xs text-white/60 hover:text-white"
          disabled={disabled}
        >
          Clear
        </button>
      ) : null}
      {open ? (
        <div className="absolute z-30 mt-1 max-h-56 w-full overflow-auto rounded-lg border border-white/15 bg-black shadow-lg">
          {loading ? (
            <div className="px-3 py-2 text-xs text-white/60">Loading pages...</div>
          ) : items.length ? (
            items.map((item) => (
              <button
                key={item.id}
                type="button"
                className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-white/85 hover:bg-white/10"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => {
                  onSelect(item)
                  setQuery(item.title)
                  setOpen(false)
                }}
              >
                <span className="font-medium">{item.title}</span>
                <span className="text-xs text-white/55">@{item.slug}</span>
              </button>
            ))
          ) : (
            <div className="px-3 py-2 text-xs text-white/60">No pages found</div>
          )}
        </div>
      ) : null}
    </div>
  )
}
